// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "micro-base-static/css/" + (chunkId === 699 ? "system" : chunkId) + "." + {"211":"339cb39d","699":"f8683ac4","960":"9369e172"}[chunkId] + ".chunk.css";
};